var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('v-row',[_c('h1',[_vm._v("Driver Dashboard")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }